module.exports = __webpack_public_path__ + "img/2.277377b.png";